<template>
    <v-navigation-drawer
        v-model="drawer"          
        width="500"
        app
        temporary
        right
        class="wost-drawer"
    >
        <div class="form-head">
            {{ titleForm }}
        </div>
        <div class="pl-3 pt-3 pr-3">
            <v-card>
                <v-card-text v-if="actionCrud == 'close'">
                    <template>
                        <v-row>
                            <v-col cols="6">
                                <v-text-field
                                    label="Monto en efectivo"
                                    outlined
                                    type="number"
                                    hide-details
                                    prefix="S/"
                                    v-model="amount_cash"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="6">
                                <v-text-field
                                    label="Monto Esperado"
                                    outlined
                                    type="number"
                                    hide-details
                                    prefix="S/"
                                    disabled
                                    v-model="totalMoney"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="6">
                                <v-text-field
                                    label="Monto en tarjetas"
                                    outlined
                                    type="number"
                                    hide-details
                                    prefix="S/"
                                    v-model="amount_cards"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="6">
                                <v-text-field
                                    label="Monto Esperado"
                                    outlined
                                    type="number"
                                    hide-details
                                    prefix="S/"
                                    disabled
                                    v-model="totalCards"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </template>
                </v-card-text>

                <v-card-text v-else>
                    <template>
                        <v-row>
                            <v-col cols="12">
                                <v-text-field
                                    label="Monto"
                                    outlined
                                    type="number"
                                    hide-details
                                    prefix="S/"
                                    v-model="amount_operation"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                <v-textarea
                                    outlined
                                    label="Descripción"
                                    hide-details
                                    v-model="description_operation"
                                ></v-textarea>
                            </v-col>
                        </v-row>
                    </template>
                </v-card-text>

            </v-card>
            <div class="mt-3">
                <template>
                    <v-row>
                        <v-col cols="6">
                            <v-btn outlined color="red darken-1" @click="handleCancel" block>
                                Cancelar
                            </v-btn>
                        </v-col>
                        <v-col cols="6">
                            <v-btn v-if="actionCrud=='close'" dark color="primary" block @click="handleCloseCash">
                                Cerrar Caja
                            </v-btn>
                            <v-btn v-else dark color="primary" block @click="handleSaveOperation">
                                Guardar
                            </v-btn>
                        </v-col>
                    </v-row>
                </template>
            </div>
        </div>
    </v-navigation-drawer>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';

import ApiCashflow from '../../apis/Cashflow'

export default {
    name: 'Form',
    data() {
        return {
            titleForm: '',
            drawer: false,
            actionCrud: '',
            cash_id: '',
            amount_operation: null,
            description_operation: null,
            amount_cash: null,
            amount_cards: null
        }
    },    
    computed: {
        ...mapState('cash', [
            'cashCurrent',
            'totalIncomes',
            'totalExpenses',
            'totalPayments',
            'totalSalesCash',
            'totalSalesCards',
            'totalSales',
            'totalCash',
            'totalMoney',
            'totalCards',
            'totalCash'
        ])
    },
    methods: {
        ...mapActions('cash', [
            'getIncomes',
            'getExpenses',
            'getTotalAmount',
            'getCashCurrent'
        ]),
        showForm(title, actionCrud, cash_id) {
            this.titleForm = title
            this.drawer = !this.drawer
            this.actionCrud = actionCrud
            this.cash_id = cash_id
        },
        clearData() {
            this.cash_id = null
            this.amount_operation = null
            this.description_operation = null
            this.amount_cash = null
            this.amount_cards = null
        },
        handleCancel() {
            this.clearData()
            this.drawer = false
        },
        handleSaveOperation() {
            let params = {
                cash_id: this.cash_id,
                type_operation: this.actionCrud,
                amount_operation: this.amount_operation,
                description_operation: this.description_operation
            }
            if (this.amount_operation == null || this.amount_operation == '' || parseFloat(this.amount_operation) < 0 ) {
                this.$notify({
                            group: 'foo',
                            type: 'error',
                            title: 'RESULTADO DE OPERACIÓN',
                            text: 'El monto debe ser mayor que cero.'
                        })
            } else {
                ApiCashflow.saveOperation(params)
                    .then(({data}) => {
                        if (this.actionCrud == 'income') {
                            this.getIncomes(this.cashCurrent.id)
                        } else if(this.actionCrud == 'expense') {
                            this.getExpenses(this.cashCurrent.id)
                        }
                        this.getTotalAmount(this.cashCurrent.id)
                        this.clearData()
                        this.drawer = false
                    })
            }            
        },
        handleCloseCash() {
            if(this.amount_cash ==null || this.amount_cards== null || parseFloat(this.amount_cash) < 0 || parseFloat(this.amount_cards) < 0) {
                this.$notify({
                            group: 'foo',
                            type: 'error',
                            title: 'RESULTADO DE OPERACIÓN',
                            text: 'Los montos ingresados deben ser mayores a cero.'
                        })
            } else {
                let condition = 'cuadre'

                if(parseFloat(this.amount_cash) < this.totalMoney) {
                    condition = 'faltante'
                }
                if(parseFloat(this.amount_cash) > this.totalMoney) {
                    condition = 'sobrante'
                }

                if(parseFloat(this.amount_cards) < this.totalCards) {
                    condition = 'faltante'
                }
                if(parseFloat(this.amount_cards) > this.totalCards) {
                    condition = 'sobrante'
                }

                let params = {
                    cash_id: this.cash_id,
                    amount_cash: this.amount_cash,
                    amount_cards: this.amount_cards,
                    amount_income: this.totalIncomes,
                    amount_expense: this.totalExpenses,
                    total_amount: this.totalCash,
                    condition: condition
                }
                ApiCashflow.close(params)
                        .then(({data}) => {
                            this.clearData()
                            this.getCashCurrent()
                            this.drawer = false
                        })
            }
            
        }
    }
}
</script>

<style>

</style>